var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app flex-row align-items-center",
      staticStyle: {
        background:
          "url('../../static/img/login-bg.jpg') no-repeat center center fixed",
        "-webkit-background-size": "cover",
        "-moz-background-size": "cover",
        "-o-background-size": "cover",
        "background-size": "cover"
      }
    },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _c(
                    "b-card-group",
                    {
                      staticClass: "login-modal-card-group",
                      attrs: { "no-border": "" }
                    },
                    [
                      _c(
                        "b-card",
                        {
                          staticClass: "p-4 login-modal-card",
                          attrs: { "no-body": "" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.submit.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c(
                            "b-card-body",
                            [
                              _c("img", {
                                attrs: {
                                  src: "/static/img/new-logo.png",
                                  height: "40",
                                  width: "130"
                                }
                              }),
                              _vm._v(" "),
                              _c("a", {
                                staticClass: "btn-close-modal",
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    return _vm.backToLogin()
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "login-modal-title-wrapper" },
                                [
                                  _vm.callStatus == "send" ||
                                  _vm.callStatus == "sending"
                                    ? _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "login-modal-title login-modal-title--bold"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Reset your password\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.callStatus == "sent" ||
                                  _vm.callStatus == "sendAgain"
                                    ? _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "login-modal-title login-modal-title--bold"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Check your inbox\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.callStatus == "error"
                                    ? _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "login-modal-title login-modal-title--bold"
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Error!\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _vm.callStatus == "send" ||
                              _vm.callStatus == "sending"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "login-modal-text login-modal-text"
                                    },
                                    [
                                      _vm._v(
                                        "\n                Enter your account email to receive a password reset link.\n              "
                                      )
                                    ]
                                  )
                                : _vm.callStatus == "sent" ||
                                  _vm.callStatus == "sendAgain"
                                ? _c("div", { staticClass: "mb-4" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "login-modal-text login-modal-text--normal mb-1"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  We have sent an email to " +
                                            _vm._s(_vm.email) +
                                            " with a link to reset your password.\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "login-modal-text login-modal-text--normal"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  It may take a few minutes for the email to arrive. If you don’t see anything after 10 minutes, check your junk or spam folder.\n                "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm.callStatus == "error"
                                ? _c("p", { staticClass: "login-modal-text" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.errormsg) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.callStatus === "send" ||
                              _vm.callStatus === "sending"
                                ? _c(
                                    "b-input-group",
                                    { staticClass: "login-modal-form-input" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.email,
                                            expression: "email"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required|email",
                                            expression: "'required|email'"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "email",
                                          required: "",
                                          id: "email",
                                          "aria-describedby": "emailHelp",
                                          placeholder: "Email",
                                          name: "email",
                                          "data-vv-delay": "500"
                                        },
                                        domProps: { value: _vm.email },
                                        on: {
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.forgotSend.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                          focus: _vm.sendAgain,
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.email = $event.target.value
                                          }
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.inputValidationErrors.has(
                                        "email"
                                      ),
                                      expression:
                                        "inputValidationErrors.has('email')"
                                    }
                                  ],
                                  staticClass: "alert-text help is-danger-msg"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inputValidationErrors.first("email")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "login-modal-footer login-modal-footer--no-border"
                                },
                                [
                                  _vm.callStatus == "send"
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "button-regular button-regular--send px-4 login-modal-btn login-modal-btn--bold login-modal-btn--full-width",
                                          attrs: {
                                            type: "submit",
                                            variant: "primary"
                                          },
                                          on: { click: _vm.forgotSend }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Send Reset Link\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.callStatus == "sending"
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "button-regular button-regular--sending px-4 login-modal-btn login-modal-btn--bold login-modal-btn--full-width",
                                          attrs: {
                                            type: "submit",
                                            variant: "primary"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Sending...\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.callStatus == "sent" ||
                                  _vm.callStatus == "sendAgain"
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "button-regular button-regular--send px-4 login-modal-btn login-modal-btn--bold login-modal-btn--full-width",
                                          attrs: {
                                            type: "submit",
                                            variant: "primary"
                                          },
                                          on: { click: _vm.forgotSend }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Resend Link\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.callStatus == "error"
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "button-regular button-regular--send login-modal-btn login-modal-btn--bold login-modal-btn--full-width",
                                          attrs: { type: "submit" },
                                          on: { click: _vm.tryAgain }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Try Again\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.callStatus === "sent" ||
                              _vm.callStatus === "sendAgain" ||
                              _vm.callStatus === "error"
                                ? _c(
                                    "div",
                                    { staticClass: "login-modal-box--center" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "login-modal-text" },
                                        [
                                          _vm._v(
                                            "\n                  Having trouble?\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "login-modal-text login-modal-text--link",
                                          attrs: {
                                            target: "_blank",
                                            href:
                                              "mailto:lighthouse@alliesagainstslavery.org"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Contact Support\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be85c97a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be85c97a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/ForgotPassword.vue
// module id = 1802
// module chunks = 0